import { render, staticRenderFns } from "./HomeworkApproveDetail.vue?vue&type=template&id=290e3f84&scoped=true&"
import script from "./HomeworkApproveDetail.vue?vue&type=script&lang=js&"
export * from "./HomeworkApproveDetail.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkApproveDetail.vue?vue&type=style&index=0&id=290e3f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e3f84",
  null
  
)

export default component.exports